import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Container, Flex, Heading, Paragraph, Text, get } from "theme-ui";
import { motion } from "framer-motion";

import terms from "src/content/terms.json";
import { viewVariants } from "src/utils";

export const Terms = () => {
  const [searchParams] = useSearchParams();
  useEffect(() => {
    const section = searchParams.get("section");
    if (section) {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [searchParams]);
  return (
    <motion.div
      variants={viewVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <Container
        as="main"
        sx={{ p: 4, maxWidth: (theme) => get(theme, "breakpoints.2") }}
      >
        <Flex
          as="article"
          sx={{
            flexDirection: "column",

            px: [2, 6, 9, 10],
          }}
        >
          <Box
            sx={{
              mt: [5, 6, 7],
            }}
          >
            <Heading
              as="h1"
              sx={{
                fontSize: [5, 5, 7],
                fontWeight: 800,
                display: "block",
                mb: [3, 3, 4],
                textAlign: "center",
              }}
            >
              {terms["terms&condition"].title}
            </Heading>
          </Box>
          {terms["terms&condition"].content.map((item, index) => {
            return (
              <Box key={index} sx={{ pt: [2, 2, 4] }}>
                {item.title && (
                  <Text
                    id={item.title}
                    as="h2"
                    sx={{ fontWeight: "heading", fontSize: [2, 2, 3] }}
                  >
                    {item.title}
                  </Text>
                )}
                {item.subtitle && (
                  <Text
                    as="p"
                    sx={{
                      fontWeight: "heading",
                      fontSize: [2, 2, 3],
                      whiteSpace: "pre-wrap",
                    }}
                  >
                    {item.subtitle}
                  </Text>
                )}
                <Paragraph
                  dangerouslySetInnerHTML={{ __html: item.text as string }}
                  sx={{ fontSize: [2, 2, 3], whiteSpace: "pre-wrap" }}
                />
              </Box>
            );
          })}
        </Flex>
      </Container>
    </motion.div>
  );
};
